export const AUDIENCE_TYPE = 'audience_type__c';
export const CHANNEL_TYPE = 'channel_type__c';
export const CONTENT_TYPE = 'content_type__c';
